export const CONSTANT = {
    INTERVAL: process.env.REACT_APP_INTERVAL || 20000,
    CHART_COLOUR: process.env.REACT_APP_CHART_COLOUR || "34a1ff",
    IS_ONE: process.env.REACT_APP_BASE_UNIT === 'ONE'
};

export const RANGE_BUTTON = [
    {
        type: "month",
        count: 1,
        text: "1m",
    },
    {
        type: "month",
        count: 3,
        text: "3m",
    },
    {
        type: "year",
        count: 1,
        text: "1y",
    },
    {
        type: "all",
        text: "All",
    },
];

export type SmartContractLicenseType =
    | "none"
    | "unlicense"
    | "mit"
    | "gnu_gpl_v2"
    | "gnu_gpl_v3"
    | "gnu_lgpl_v2_1"
    | "gnu_lgpl_v3"
    | "bsd_2_clause"
    | "bsd_3_clause"
    | "mpl_2_0"
    | "osl_3_0"
    | "apache_2_0"
    | "gnu_agpl_v3"
    | "bsl_1_1";

interface ContractLicense {
    type: SmartContractLicenseType;
    url: string;
    label: string;
    title: string;
}

export const CONTRACT_LICENSES: Array<ContractLicense> = [
    {
        type: "none",
        label: "None",
        title: "No License",
        url: "https://choosealicense.com/no-permission/",
    },
    {
        type: "unlicense",
        label: "Unlicense",
        title: "The Unlicense",
        url: "https://choosealicense.com/licenses/unlicense/",
    },
    {
        type: "mit",
        label: "MIT",
        title: "MIT License",
        url: "https://choosealicense.com/licenses/mit/",
    },
    {
        type: "gnu_gpl_v2",
        label: "GNU GPLv2",
        title: "GNU General Public License v2.0",
        url: "https://choosealicense.com/licenses/gpl-2.0/",
    },
    {
        type: "gnu_gpl_v3",
        label: "GNU GPLv3",
        title: "GNU General Public License v3.0",
        url: "https://choosealicense.com/licenses/gpl-3.0/",
    },
    {
        type: "gnu_lgpl_v2_1",
        label: "GNU LGPLv2.1",
        title: "GNU Lesser General Public License v2.1",
        url: "https://choosealicense.com/licenses/lgpl-2.1/",
    },
    {
        type: "gnu_lgpl_v3",
        label: "GNU LGPLv3",
        title: "GNU Lesser General Public License v3.0",
        url: "https://choosealicense.com/licenses/lgpl-3.0/",
    },
    {
        type: "bsd_2_clause",
        label: "BSD-2-Clause",
        title: 'BSD 2-clause "Simplified" license',
        url: "https://choosealicense.com/licenses/bsd-2-clause/",
    },
    {
        type: "bsd_3_clause",
        label: "BSD-3-Clause",
        title: 'BSD 3-clause "New" Or "Revised" license',
        url: "https://choosealicense.com/licenses/bsd-3-clause/",
    },
    {
        type: "mpl_2_0",
        label: "MPL-2.0",
        title: "Mozilla Public License 2.0",
        url: "https://choosealicense.com/licenses/mpl-2.0/",
    },
    {
        type: "osl_3_0",
        label: "OSL-3.0",
        title: "Open Software License 3.0",
        url: "https://choosealicense.com/licenses/osl-3.0/",
    },
    {
        type: "apache_2_0",
        label: "Apache",
        title: "Apache 2.0",
        url: "https://choosealicense.com/licenses/apache-2.0/",
    },
    {
        type: "gnu_agpl_v3",
        label: "GNU AGPLv3",
        title: "GNU Affero General Public License",
        url: "https://choosealicense.com/licenses/agpl-3.0/",
    },
    {
        type: "bsl_1_1",
        label: "BSL 1.1",
        title: "Business Source License",
        url: "https://mariadb.com/bsl11/",
    },
];

export const MULTICHAIN_LIST = [
    {
        Name: "XDC Network",
        API: "https://api.xdcscan.io",
        Explorer_link: "https://xdcscan.io/",
        Symbol: "XDC",
        // isTest: false
    },
    {
        Name: "Apothem Network",
        API: "https://api-apothem.xdcscan.io",
        Explorer_link: "https://apothem.xdcscan.io/",
        Symbol: "XDC",
    },
    {
        Name: "XDC DevNet",
        API: "https://api-devnet.xdcscan.io",
        Explorer_link: "https://devnet.xdcscan.io/",
        Symbol: "XDC",
    },
    {
        Name: "Telos EVM",
        API: "https://telos.blocksscan.io/api",
        Explorer_link: "https://telos.blocksscan.io/",
        Symbol: "TLOS",
    },
    {
        Name: "Velas Network",
        API: "https://api.velasblocks.io",
        Explorer_link: "https://velasblocks.io/",
        Symbol: "VLX",
    },
    {
        Name: "WanChain",
        API: "https://api.wanexplorer.io",
        Explorer_link: "https://https://wanexplorer.io",
        Symbol: "WAN",
    },
    {
        Name: "EVMOS",
        API: "https://evmos.blocksscan.io/api",
        Explorer_link: "https://evmos.blocksscan.io/",
        Symbol: "EVMOS",
    },
    {
        Name: "NEON EVM",
        API: "https://neon.blocksscan.io/api",
        Explorer_link: "https://neon.blocksscan.io/",
        Symbol: "NEON",
    },
];

const tokenType = process.env.REACT_APP_TOKEN_TYPE || "XRC"

interface exportCsv {
    label: string;
    value: string;
    meta?: any;
}

export const EXPORT_CSV_TYPE: Array<exportCsv> = [
    {label: "Transactions", value: "transactions"},
    {label: "Internal Transactions", value: "internalTransactions"},
    {label: `Token Transfers (${tokenType}-20)`, value: "tokenTransfers", meta: {token_type: 'ERC-20'}}
]

interface ChartDetails {
    // title: string;
    sections: Array<Section>;
    // id: string | number;
}

interface Section {
    id: string;
    title: string;
    charts: Array<Chart>;
}

interface Chart {
    id: string;
    title: string;
    description: string;
    units: string | null;
    islive: boolean;
}

const baseUnit = process.env.REACT_APP_BASE_UNIT || "XDC";
const baseName = process.env.REACT_APP_BASE_NAME || "XDC Network";

export const CHART_LIST: Array<ChartDetails> = [
    {
        // id: "data1",
        // title: "Market Overview",
        sections: [
            {
                id: "marketData",
                title: "Market Data",
                charts: [
                    {
                        id: "market",
                        title: "Daily Price (USD) Chart",
                        description: `The ${baseUnit} Daily Price (USD) chart shows the daily historical price for ${baseUnit} in USD.`,
                        units: null,
                        islive: true
                    }
                ]
            },
            {
                id: "accounts",
                title: "Accounts",
                charts: [
                    {
                        id: "accountsGrowth",
                        title: "Daily Accounts Growth Chart",
                        description: "Cumulative accounts number per period",
                        units: null,
                        islive: true
                    },
                    {
                        id: "activeAccounts",
                        title: "Daily Active Accounts Chart",
                        description: "Active accounts number per period",
                        units: null,
                        islive: true
                    },
                    {
                        id: "newAccounts",
                        title: "Daily New Accounts Chart",
                        description: "New accounts number per day",
                        units: null,
                        islive: true
                    }
                ]
            },
            {
                id: "transactions",
                title: "Transactions",
                charts: [
                    {
                        id: "averageTxnFee",
                        title: "Average transaction fee Chart",
                        description: `The chart shows the daily average amount in USD spent per transaction on the ${baseName}.`,
                        units: "ETH",
                        islive: true
                    },
                    {
                        id: "newTxns",
                        title: "Daily Transactions Chart",
                        description: `The chart highlights the total number of transactions on the ${baseUnit} blockchain with daily individual breakdown for average difficulty, estimated hash rate, average block time and size, total block and uncle block count and total new address seen.`,
                        units: null,
                        islive: true
                    },
                    {
                        id: "txnsFee",
                        title: "Daily Transactions Fees Chart",
                        description: "Amount of tokens paid as fees",
                        units: "ETH",
                        islive: true
                    },
                    {
                        id: "txnsGrowth",
                        title: "Daily Transactions growth Chart",
                        description: "Cumulative transactions number",
                        units: null,
                        islive: true
                    },
                    {
                        id: "txnsSuccessRate",
                        title: "Daily Transactions Success Rate Chart",
                        description: "Successful transactions rate per day",
                        units: null,
                        islive: true
                    }
                ]
            },
            {
                id: "blocks",
                title: "Blocks",
                charts: [
                    {
                        id: "averageBlockSize",
                        title: "Average Block Size Chart",
                        description: `The ${baseUnit} Average Block Size Chart indicates the historical average block size in bytes of the ${baseName} blockchain.`,
                        units: "Bytes",
                        islive: true
                    },
                    {
                        id: "newBlocks",
                        title: "Daily New blocks Chart",
                        description: "New blocks number",
                        units: null,
                        islive: true
                    }
                ]
            },
            {
                id: "tokens",
                title: "Tokens",
                charts: [
                    {
                        id: "newNativeCoinTransfers",
                        title: `Daily New Transfers Chart`,
                        description: `The chart shows the number of ${tokenType}-20 tokens transferred daily.`,
                        units: null,
                        islive: true
                    }
                ]
            },
            {
                id: "gas",
                title: "Gas",
                charts: [
                    {
                        id: "averageGasLimit",
                        title: "Average Gas Limit Chart",
                        description: `The ${baseUnit} Average Gas Limit Chart shows the historical daily average gas limit of the ${baseName}.`,
                        units: null,
                        islive: true
                    },
                    {
                        id: "averageGasPrice",
                        title: "Average Gas Price Chart",
                        description: `The ${baseUnit} Average Gas Price Chart shows the daily average gas price used of the ${baseName}.`,
                        units: "Gwei",
                        islive: true
                    },
                    {
                        id: "gasUsedGrowth",
                        title: "Daily Gas Used Growth Chart",
                        description: "Cumulative gas used for the period",
                        units: null,
                        islive: true
                    }
                ]
            },
            {
                id: "contracts",
                title: "Contracts",
                charts: [
                    {
                        id: "contractsGrowth",
                        title: "Daily Contracts Growth Chart",
                        description: "Cumulative number of contracts for the period",
                        units: null,
                        islive: true
                    },
                    {
                        id: "newContracts",
                        title: "Daily New contracts Chart",
                        description: "New contracts number for the period",
                        units: null,
                        islive: true
                    },
                    {
                        id: "newVerifiedContracts",
                        title: "Daily Verified Contracts Chart",
                        description: "The chart shows the total number of contracts verified daily. Check out the 500 most recent verified contracts!",
                        units: null,
                        islive: true
                    },
                    {
                        id: "verifiedContractsGrowth",
                        title: "Daily Verified Contracts Growth Chart",
                        description: "Cumulative number verified contracts for the period",
                        units: null,
                        islive: true
                    }
                ]
            }
        ]
    }
];

export const COUNTRY: any = {
    "AF": "Afghanistan",
    "AX": "land Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "AndorrA",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo",
    "CD": "Congo, The Democratic Republic of the",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "Cote D'Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "FK": "Falkland Islands (Malvinas)",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and Mcdonald Islands",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic Of",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea, Democratic People'S Republic of",
    "KR": "Korea, Republic of",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People'S Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libyan Arab Jamahiriya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia, The Former Yugoslav Republic of",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia, Federated States of",
    "MD": "Moldova, Republic of",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "The Netherlands",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestinian Territory, Occupied",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "RWANDA",
    "SH": "Saint Helena",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan, Province of China",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UM": "United States Minor Outlying Islands",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "VietNam",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
}